import { Button } from "@mui/material";
import { Chip } from "components/atoms/Chip";
import { TableColumn } from "react-data-table-component";
import { stringWithDefault } from "utils/data-table-utils";
import { DataRow } from "./types";
import { Feature } from "types/api";

const isUnlabeled = (row: DataRow) =>
  !row?.title && (!row?.cognitiveDomains || row?.cognitiveDomains?.length < 1);

const byUnlabelledThenDateDescending = (
  rowA: DataRow,
  rowB: DataRow
): number => {
  if (isUnlabeled(rowA) && !isUnlabeled(rowB)) {
    return -1;
  }
  if (isUnlabeled(rowB) && !isUnlabeled(rowA)) {
    return 1;
  }
  const rowADate = rowA?.fullISODate;
  const rowBDate = rowB?.fullISODate;
  if (rowADate > rowBDate) {
    return -1;
  }
  return 1;
};

export const ACTIVITY_LIBRARY_COLUMNS: TableColumn<DataRow>[] = [
  {
    name: "ID",
    selector: (row) => row.id,
    omit: true,
  },
  {
    name: "Title",
    selector: (row) => stringWithDefault(row.title),
    cell: (row) => (
      <Button
        href={`/activity-details/${row.id}`}
        rel="noreferrer noopener"
        target="_blank"
        sx={{ textTransform: "none" }}
      >
        {stringWithDefault(row.title)}
      </Button>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: "Difficulty",
    selector: (row) => row.difficulty || "-",
    sortable: true,
    cell: (row) => {
      if (
        row.feature === Feature.HealthyBrainActivity ||
        row.feature === Feature.CompensatoryStrategies
      ) {
        return row.difficulty || "-";
      }
      return "-";
    },
  },
  {
    name: "Recorder",
    selector: (row) => stringWithDefault(row.recorder),
    sortable: true,
    wrap: true,
  },

  {
    name: "Cog Domain",
    selector: (row) => row.cognitiveDomains?.join(", ") || "-",
    sortable: true,
    wrap: true,
  },

  {
    name: "Status",
    selector: (row) => row.status,
    cell: (row) => <Chip>{row.status}</Chip>,
    sortable: true,
  },
  {
    name: "Activity Created",
    selector: (row) => row.newlyCreated,
    cell: (row) =>
      row.newlyCreated ? (
        <Chip style={{ backgroundColor: "#000", color: "#fff" }}>
          {row.newlyCreated}
        </Chip>
      ) : (
        ""
      ),
    sortable: true,
  },
  {
    name: "Created On",
    selector: (row) => row.fullISODate,
    cell: (row) => row.dateRecorded,
    sortable: true,
    sortFunction: byUnlabelledThenDateDescending,
  },
];
